import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { AppLoginPrincipalContainerModel } from '../../../../../models/aggregates/app-login';

@Injectable({ providedIn: 'root' })
export class AppLoginPrincipalLoginTenantEpService extends BaseApiTemplateService<AppLoginPrincipalContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX + 'app-login-principal/login-tenant-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX + 'app-login-principal/login-tenant-ep';
    this.httpClient = http;
  }
}
